import React from 'react';

const Divider = ({ children }) => (
    <div className="divider"></div>
);

export default Divider;